// Modules
import { Store, select } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';

// Rxjs
import { Subscription } from 'rxjs';

// Constants & Helpers
import { APP_PATHS_CONSTANTS } from '@shared/constants';
import * as NavigationHelper from '@shared/helpers/navigation.helper';
import * as VIEWPROFILE_CONSTANTS from '@shared/enums/viewProfileEnums';
// Store - Reducer
import { AppState } from '@store/reducers';

// Store - Actions
import * as GeneralActions from '@store/actions/general.actions';
import * as ViewProfileActions from '@store/actions/view-profile.actions';

// Store - Selectors
import * as ViewProfileSelectors from '@store/selectors/view-profile.selectors';

// Store - Services
import { AppConfigService } from '@shared-module/services/app-config/app-config.service';

// Interfaces
import { IUser } from '@shared/interfaces/users';
import { DOC_TYPE } from '@app/general/shared/constants/profile';
import {
  defaultUserPermissions,
  mappedPortals,
} from '@app/modules/users/utils/constants/users';

@Component({
  selector: 'sbi-cot-back-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.scss'],
  standalone: false,
})
export class ViewProfileComponent implements OnInit {
  // Variables públicas
  public loading: boolean;
  public viewProfileForm: FormGroup;
  public user: IUser;
  public rolesEnum = VIEWPROFILE_CONSTANTS.rolesEnum;
  public roleList: string[] = [];
  public permissionsSistema = [];
  public permissionsGestionUsuario = [];
  public permissionsGeneralAutogestion = [];
  public permissionsFianzas = [];
  public permissionsCampaigns = [];
  public permissionsAccidents = [];
  public permissionsAccounts = [];
  public permissionsRenewals = [];
  public permissionsMultiproducto = [];
  public permissionsCommissions = [];
  public permissionsTransport = [];
  public permissionsRentGuarantee = [];
  public permissionsPublicPortal = [];
  public permissionsTravel = [];
  public DOC_TYPE = DOC_TYPE;
  public orderedPermissionsForDetail: any = null;
  public mappedPortals = mappedPortals;
  // Default variables
  public data = defaultUserPermissions;

  private _userProfileRequest$ = this._store$.pipe(
    select(ViewProfileSelectors.selectUserProfile)
  );

  private _subscriptions$: Subscription[] = [];

  // Selectores públicos
  public loading$ = this._store$.pipe(
    select(ViewProfileSelectors.selectViewProfileLoading)
  );
  loggedUser = JSON.parse(
    sessionStorage.getItem(this._app.loggedUserSessionKey)
  );

  constructor(
    private _app: AppConfigService,
    private _store$: Store<AppState>,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    // Building forms
    this._buildprofileForm();

    // Set current navigation
    this._store$.dispatch(
      GeneralActions.setCurrentPage({
        payload: NavigationHelper.getNotMenuNavigationItem(
          APP_PATHS_CONSTANTS.VIEW_PROFILE
        ),
      })
    );

    // Get request
    this._getUserProfile();

    this._parseUserProfile();
  }

  // Method to get a Request by ID
  private _getUserProfile(): void {
    this.loading = true;

    this._store$.dispatch(ViewProfileActions.getUserProfileRequested());
  }

  // Method to build the Request Form
  private _buildprofileForm(): void {
    this.viewProfileForm = this._formBuilder.group({
      firstName: [{ value: '', disabled: true }],
      lastName: [{ value: '', disabled: true }],
      documentId: [{ value: '', disabled: true }],
      documentType: [{ value: '', disabled: true }],
      rut: [{ value: '', disabled: true }],
      cardCode: [{ value: '', disabled: true }],
      insuredRut: [{ value: '', disabled: true }],
      insuredCardCode: [{ value: '', disabled: true }],
      dispatcherManagedCompanies: [{ value: [], disabled: true }],
      email: [{ value: '', disabled: true }],
      cellPhone: [{ value: '', disabled: true }],
      address: [{ value: '', disabled: true }],
      password: [{ value: '', disabled: true }],
      roles: [{ value: [], disabled: true }],
      permissions: this._formBuilder.group({
        //Sistema
        1001: [{ value: true, disabled: true }],
        1002: [{ value: true, disabled: true }],
        1003: [{ value: true, disabled: true }],
        //  Gestión Usuarios
        2001: [{ value: true, disabled: true }],
        2002: [{ value: true, disabled: true }],
        2003: [{ value: true, disabled: true }],
        2004: [{ value: true, disabled: true }],
        2005: [{ value: true, disabled: true }],
        2006: [{ value: true, disabled: true }],
        // General - AutoGestión
        '020101': [{ value: true, disabled: true }],
        3001: [{ value: true, disabled: true }],
        3002: [{ value: true, disabled: true }],
        3003: [{ value: true, disabled: true }],
        3004: [{ value: true, disabled: true }],
        3005: [{ value: true, disabled: true }],
        // Se agrega como string ya que el numero iniciado en 0 da un error de validez
        '010301': [{ value: true, disabled: true }],
        '010302': [{ value: true, disabled: true }],
        '020201': [{ value: true, disabled: true }],
        '010501': [{ value: true, disabled: true }],
        '010502': [{ value: true, disabled: true }],
        // General - Transporte
        '030001': [{ value: true, disabled: true }],
        '030003': [{ value: true, disabled: true }],
        // Fianzas
        4001: [{ value: true, disabled: true }],
        4002: [{ value: true, disabled: true }],
        4003: [{ value: true, disabled: true }],
        4004: [{ value: true, disabled: true }],
        // Campañas
        5001: [{ value: true, disabled: true }],
        // Siniestros
        6001: [{ value: true, disabled: true }],
        6002: [{ value: true, disabled: true }],
        6003: [{ value: true, disabled: true }],
        // Cuentas
        7001: [{ value: true, disabled: true }],
        '031010': [{ value: true, disabled: true }],
        // Api Corredores
        '040101': [{ value: true, disabled: true }],
        // Renovaciones
        '010601': [{ value: true, disabled: true }],
        '020301': [{ value: true, disabled: true }],
        '010602': [{ value: true, disabled: true }],
        '020302': [{ value: true, disabled: true }],
        // Administrador - Multiproducto
        '010801': [{ value: true, disabled: true }],
        // Corredores - Ver Comisiones
        '021601': [{ value: true, disabled: true }],
        '021602': [{ value: true, disabled: true }],
        // Corredores - Multiproducto
        '020501': [{ value: true, disabled: true }],
        // Transporte - Administrador
        '010903': [{ value: true, disabled: true }],
        '010905': [{ value: true, disabled: true }],
        '010906': [{ value: true, disabled: true }],
        '010907': [{ value: true, disabled: true }],
        '010908': [{ value: true, disabled: true }],
        '010909': [{ value: true, disabled: true }],
        // Transporte - Corredores
        '020903': [{ value: true, disabled: true }],
        '020905': [{ value: true, disabled: true }],
        '020909': [{ value: true, disabled: true }],
        // Transporte - Autogestión
        '030903': [{ value: true, disabled: true }],
        '030905': [{ value: true, disabled: true }],
        '030909': [{ value: true, disabled: true }],
        // Garantia alqules - Administrador
        '011001': [{ value: true, disabled: true }],
        '011002': [{ value: true, disabled: true }],
        '011003': [{ value: true, disabled: true }],
        // Garantia alqules - Corredores
        '021001': [{ value: true, disabled: true }],
        '021002': [{ value: true, disabled: true }],
        '021003': [{ value: true, disabled: true }],
        // Portal público
        '050101': [{ value: true, disabled: true }],
        // Acceso - viajes - Corredores
        '021111': [{ value: true, disabled: true }],
        // Configuración - Documentos por producto
        '011703': [{ value: true, disabled: true }],
      }),
    });
  }

  // Method to get a request and fill de form
  private _parseUserProfile(): void {
    // Parseamos la respuesta de la solicitud
    this._subscriptions$.push(
      this._userProfileRequest$.subscribe((userRequest: IUser) => {
        if (userRequest) {
          this.user = userRequest;
          if (userRequest.permissions && userRequest.permissions.length > 0) {
            this.orderedPermissionsForDetail =
              this._getOrderedPermissionsStructure(userRequest.permissions);
          } else {
            this.orderedPermissionsForDetail = [];
          }
          this.loading = false;
          if (userRequest) {
            const firstName = this.viewProfileForm.get('firstName');
            const lastName = this.viewProfileForm.get('lastName');
            const documentId = this.viewProfileForm.get('documentId');
            const documentType = this.viewProfileForm.get('documentType');
            const rut = this.viewProfileForm.get('rut');
            const cardCode = this.viewProfileForm.get('cardCode');
            const insuredRut = this.viewProfileForm.get('insuredRut');
            const insuredCardCode = this.viewProfileForm.get('insuredCardCode');
            const dispatcherManagedCompanies = this.viewProfileForm.get(
              'dispatcherManagedCompanies'
            );
            const email = this.viewProfileForm.get('email');
            const cellPhone = this.viewProfileForm.get('cellPhone');
            const address = this.viewProfileForm.get('address');
            const roles = this.viewProfileForm.get('roles');

            // Rellenamos el Estado
            firstName.patchValue(userRequest.firstName);
            lastName.patchValue(userRequest.lastName);
            documentId.patchValue(userRequest.documentId);
            documentType.patchValue(userRequest.documentType);
            email.patchValue(userRequest.email);
            cellPhone.patchValue(userRequest.cellPhone);
            address.patchValue(userRequest.address);
            rut.patchValue(userRequest.brokerRut);
            cardCode.patchValue(userRequest.cardCode);
            insuredRut.patchValue(userRequest.insuredCompanyRut);
            insuredCardCode.patchValue(userRequest.insuredCompanyCardCode);
            dispatcherManagedCompanies.patchValue(
              userRequest.dispatcherManagedCompanies
            );
            this._setPermissionData(userRequest.permissions);
            roles.patchValue(userRequest.roles);
          }
        }
      })
    );
  }

  private _getOrderedPermissionsStructure(permissions: string[]): any {
    const totalPermissions = permissions.sort((a, b) => {
      //Funcion para ordenar por portal según su codigo(primeros dos digitos)
      const numA = parseInt(a.substring(0, 2), 10) || 0;
      const numB = parseInt(b.substring(0, 2), 10) || 0;
      return numA - numB;
    });
    const orderedPermissions = [];
    totalPermissions.forEach(code => {
      const portalMap: Record<string, string> = {
        '01': 'Backoffice',
        '02': 'Corredores',
        '03': 'Autogestion',
        '04': 'Partners',
        '05': 'PortalPublico',
        '06': 'Servicios Externos',
      };

      const moduleMap: Record<string, string> = {
        '01': 'Usuarios',
        '03': 'Cartera',
        '06': 'Renovaciones',
        '07': 'Automóviles',
        '08': 'Multiseguros',
        '09': 'Transporte',
        '10': 'Gestión de cuentas',
        '11': 'Viajes',
        '12': 'Campañas',
        '13': 'Fianza',
        '14': 'Siniestros',
        '15': 'Garantía de Alquiler',
        '16': 'Comisiones',
        '17': 'Configuración',
        '18': 'Gestión de tarifa automóviles',
        '00': 'Servicios externos',
      };

      const portalCode = code.substring(0, 2);
      const moduleCode = code.substring(2, 4);

      //Servicios externos y Partners tienen el mismo codigo de portal
      const portalName = portalMap[portalCode];
      const moduleName =
        portalName === 'Servicios Externos'
          ? 'Servicios externos'
          : moduleMap[moduleCode]; //|| `modulo_${moduleCode}`;

      // Buscar si el portal ya existe en el array
      let portal = orderedPermissions.find(p => p.portal === portalName);

      if (!portal) {
        portal = { portal: portalName, modules: [] };
        orderedPermissions.push(portal);
      }

      // Buscar si el módulo ya existe dentro del portal
      let module = portal.modules.find(m => m.module === moduleName);
      if (!module) {
        module = { module: moduleName, permissions: [] };
        //   // Excepcion con Web y Api partners, en ambos el modulo es 00
        if (
          portalName === 'PortalPublico' &&
          moduleName === 'Servicios externos'
        )
          module = {
            module: 'Web',
            permissions: [],
          };
        if (portalName === 'Partners' && moduleName === 'Servicios externos')
          module = {
            module: 'Api partners',
            permissions: [],
          };
        portal.modules.push(module);
      }

      module.permissions.push({
        code: code,
        name: this._getNameByCode(code),
      });
    });

    return orderedPermissions;
  }

  private _getNameByCode(code: string): string {
    return this.data.reduce((acc, portal) => {
      const module = portal.modules.find(module =>
        module.permissions.find(perm => perm.code === code)
      );
      if (module) {
        const permission = module.permissions.find(perm => perm.code === code);
        return permission.name;
      }
      return acc;
    }, '');
  }

  private _setPermissionData(permissions): void {
    this.permissionsSistema = [];
    this.permissionsGeneralAutogestion = [];
    this.permissionsGestionUsuario = [];
    this.permissionsFianzas = [];
    this.permissionsCampaigns = [];
    this.permissionsAccidents = [];
    this.permissionsAccounts = [];
    this.permissionsRenewals = [];
    this.permissionsMultiproducto = [];
    this.permissionsCommissions = [];
    this.permissionsTransport = [];
    this.permissionsRentGuarantee = [];
    this.permissionsPublicPortal = [];
    this.permissionsTravel = [];

    VIEWPROFILE_CONSTANTS.permissionsSistema.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsSistema.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsGeneralAutogestion.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsGeneralAutogestion.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsGestionUsuario.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsGestionUsuario.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsFianzas.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsFianzas.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsCampaigns.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsCampaigns.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsAccidents.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsAccidents.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsAccounts.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsAccounts.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsRenewals.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsRenewals.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsMultiproducto.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsMultiproducto.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsCommissions.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsCommissions.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsTransport.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsTransport.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsRentGuarantee.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsRentGuarantee.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsPublicPortal.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsPublicPortal.push(data);
    });

    VIEWPROFILE_CONSTANTS.permissionsTravel.map(data => {
      if (permissions.indexOf(data.code) >= 0)
        this.permissionsTravel.push(data);
    });
  }

  public getFormControl(name: string): AbstractControl {
    return this.viewProfileForm.get(name);
  }

  public getRoleName(id: string): string {
    return this.rolesEnum.find(r => r.item_id == id)
      ? this.rolesEnum.find(r => r.item_id == id).item_text
      : 'Rol no identificado';
  }

  public getRoleList(): string[] {
    let roleList = [];
    if (this.getFormControl('roles').value?.length > 0)
      this.getFormControl('roles').value.map((role, index) => {
        roleList = [...roleList, this.getRoleName(role)];
        if (index === 0) roleList = [this.getRoleName(role)];
      });
    return roleList;
  }

  public getBadgeClass(portal: string): string {
    switch (portal) {
      case VIEWPROFILE_CONSTANTS.Portals.Administrador:
        return VIEWPROFILE_CONSTANTS.PortalStyles.Main;
      case VIEWPROFILE_CONSTANTS.Portals.Corredores:
        return VIEWPROFILE_CONSTANTS.PortalStyles.Primary;
      case VIEWPROFILE_CONSTANTS.Portals.Servicios_Externos:
        return VIEWPROFILE_CONSTANTS.PortalStyles.Green;
      case VIEWPROFILE_CONSTANTS.Portals.Despachante:
        return VIEWPROFILE_CONSTANTS.PortalStyles.Purple;
      case VIEWPROFILE_CONSTANTS.Portals.Autogestion:
        return VIEWPROFILE_CONSTANTS.PortalStyles.Orange;
      case VIEWPROFILE_CONSTANTS.Portals.Partners:
        return VIEWPROFILE_CONSTANTS.PortalStyles.DarkGreen;
      default:
        return VIEWPROFILE_CONSTANTS.PortalStyles.Main;
    }
  }

  public goBack(): string {
    return `/${APP_PATHS_CONSTANTS.ADMIN_PRIVATE_WRAPPER}/${APP_PATHS_CONSTANTS.DASHBOARD_AUTO}`;
  }

  getPortalName(portal: string) {
    return this.mappedPortals.find(p => p.name.includes(portal))?.value;
  }
}
